import React, { Component } from 'react'
import { compose } from 'redux'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'

import {Cancel, Edit, Check} from "@material-ui/icons";
import Grid from '@material-ui/core/Grid'
import Delete from '@material-ui/icons/Delete'
import StyledPaper from '../../StyledPaper'
import {withStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import FactorButton from './FactorButton'
import FactorTextField from '../FactorTextField'
import {MAXIMUM_CHARACTERS_PER_FACTOR} from "../../../../constants";

const styles = theme => ({
  button: {fontSize: 25},
  buttonContainer: {minHeight: '48px'},
  floatRight: {float: 'right'},
  factorText: {fontSize: '1.15rem'}
})

export class Factor extends Component {
  constructor(props){
    super(props)

    this.state = { focused: false }
  }

  componentDidUpdate(prevProps) {
    this.newFactorInputRef && this.newFactorInputRef.focus()
  }

  render(){
    const {disabled, factor, onRemove, classes, t, buttonsDisabled, editing} = this.props
    const {focused} = this.state
    return (
      <StyledPaper>
        <Grid container alignItems="center">
          <Grid item xs={9}>
            <span className={classes.factorText}>{this.getFactor(editing, factor, t, focused)}</span>
          </Grid>
          <Grid item xs={3} className={classes.buttonContainer}>
            { (editing || !buttonsDisabled) &&
              <div className={classes.floatRight}>
                {this.getModifyButton(editing, factor, disabled, classes.button, t)}

                {this.getCancelButton(editing, disabled, classes.button, t)}

                <FactorButton disabled={disabled} onClick={onRemove} title={t('Delete Factor')}>
                  <Delete className={classes.button}/>
                </FactorButton>
              </div>
            }
          </Grid>
        </Grid>
      </StyledPaper>
    )
  }

  getCancelButton(editing, disabled, buttonClass, t) {
    if(editing)
      return (
        <FactorButton disabled={disabled}
                      onClick={this.props.onEditCancel}
                      title={t('Cancel Changes')}
                      id='cancel'
        >
          <Cancel className={buttonClass}/>
        </FactorButton>
      )
  }

  getModifyButton(editing, factor, disabled, buttonClass, t) {
    const { onDone, onEditStart, updatedFactor } = this.props
    const callback = editing ? onDone : onEditStart
    const icon = editing ? <Check className={buttonClass}/> : <Edit className={buttonClass}/>

    let title = editing ? 'Done Editing' : 'Edit'
    title += ' Factor'

    return (
      <FactorButton
        disabled={disabled || (editing && updatedFactor.length === 0)}
        onClick={callback}
        title={t(title)}
      >
        {icon}
      </FactorButton>
    )
  }

  getFactor(editing, factor, t, focused) {
    return editing ?
      <FactorTextField
        inputProps={{maxLength: MAXIMUM_CHARACTERS_PER_FACTOR}}
        inputRef={el => this.newFactorInputRef = el}
        label={
          focused ?
            t('Characters Remaining', {CHARNUM: MAXIMUM_CHARACTERS_PER_FACTOR - this.props.updatedFactor.length}) : ''
        }
        multiline={true}
        onTextFieldChange={event => this.props.onChange(event.target.value)}
        placeholder={''}
        style={{width: '100%'}}
        value={this.props.updatedFactor}
        onFocus={() => this.setState({focused: true})}
        onBlur={() => this.setState({focused: false})}
        onKeyDown={e => this.props.onKeyDown(e, this.props.updatedFactor, this.props.onDone)}
      /> :
      <Typography>
        <span style={{fontSize: '1.15rem'}}>
          {factor}
        </span>
      </Typography>
  }
}

Factor.propTypes = {
  buttonsDisabled: PropTypes.bool.isRequired,
  editing: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  factor: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  onEditStart: PropTypes.func.isRequired,
  onEditCancel: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  saveFactor: PropTypes.func,
  updatedFactor: PropTypes.string
}

export default compose(
  translate(),
  withStyles(styles)
)(Factor)


// WEBPACK FOOTER //
// ./src/components/counseling-session/enter-factors/Factor/Factor.js